export const brokerRoutes = {
  LOGIN: '/login',
  APP_DASHBOARD: '/app/board/home',
  APP_DASHBOARD_CONTACT: '/app/board/contact',
  APP_DEMARCHAGE_TELEPHONIQUE: '/app/board/demarchage-telephonique',
  APP_FAQ: '/app/board/faq',
  APP_INFOS_REGLEMENTAIRES: '/app/board/formations-reglementaires',
  APP_QUOTATION_LIST: '/app/board/quotations',
  APP_TUTORIALS: '/app/tutorials',
  APP_PRODUCTS: '/app/products',
  APP_SOUSCRIPTION_EN_LIGNE: '/souscription-en-ligne',
  APP_CAR_INSURANCE_QUOTATION: '/app/car-insurance',
  APP_CAR_INSURANCE_PRICES: '/app/car-insurance/pricing',
  APP_CAR_INSURANCE_SUBSCRIPTION: '/app/car-insurance/{0}/subscription',
  APP_CAR_INSURANCE_PAYMENT: '/app/car-insurance/{0}/payment',
  APP_CAR_INSURANCE_CONFIRMATION: '/app/car-insurance/{0}/confirmation',

  APP_HEALTH_INSURANCE_QUOTATION: '/demande-devis/devis',
  APP_HEALTH_INSURANCE_PRICING: '/demande-devis/tarif',
  APP_HEALTH_INSURANCE_SUBSCRIPTION:
    '/app/health-insurance/{0}/{1}/subscription',
  APP_HEALTH_INSURANCE_SIGNATURE: '/app/health-insurance/{0}/{1}/signature',
  APP_HEALTH_INSURANCE_CONFIRMATION:
    '/app/health-insurance/{0}/{1}/confirmation',

  APP_ROP_INSURANCE_PROFILE: '/app/rop/profile',
  APP_ROP_INSURANCE_SUBSCRIPTION: '/app/rop/subscription/{0}',
  APP_ROP_INSURANCE_CONFIRMATION: '/app/rop/confirmation/{0}',

  APP_INFORMATIONS: '/app/informations',
  APP_CLIENTS: '/app/clients/list',
  APP_CLIENTS_DETAILS_INFOS: '/app/clients/{0}/policies/{1}/infos',
  APP_CLIENTS_DETAILS_INFOS_WITH_REQUEST:
    '/app/clients/{0}/policies/{1}/infos?requestId={2}',
  APP_CLIENTS_DETAILS_DOCUMENTS: '/app/clients/{0}/policies/{1}/documents',
  APP_CLIENTS_DETAILS_PAY_COMPLEMENT:
    '/app/clients/{0}/policies/{1}/complement/{2}',
  APP_CLIENTS_DETAILS_PAY_RECEIPTS: '/app/clients/{0}/policies/{1}/payReceipts',
  APP_CLIENTS_DETAILS_PAY_RECEIPTS_CONFIRM:
    '/app/clients/{0}/policies/{1}/confirmPayReceipts',
  APP_CLIENTS_DETAILS_PAY_AVENANT_CONFIRM:
    '/app/clients/{0}/policies/{1}/confirmPayAvenant',
  APP_CLIENTS_DETAILS_PAY_COMPLEMENT_CONFIRM:
    '/app/clients/{0}/policies/{1}/confirmPayComplement',
  APP_COMMISSIONS: '/app/commissions',
  REGISTER: '/register',
  SUBSCRIPTION: '/subscription',
  SIGNATURE: '/signature',
  SIGNATURE_ETAPE1: '/signature/etape1',
  SIGNATURE_ETAPE2: '/signature/etape2',
};
